module.exports = __webpack_public_path__ + "static/media/important-to-me.c88f377e.png";